<script context="module">
    import { toast } from '@zerodevx/svelte-toast'
    const API = { }

    export function background (bool) {
        if (API.background)
            API.background (bool);
    }

    export function confirm () {
        if (API.confirm)
            API.confirm ();
    }

    export function notifySuccess (message) {
        toast.push (message, {
            theme: {
                '--toastMsgPadding': '0.5rem 1.2rem',
                '--toastBackground': '#1cbb60',
                '--toastColor': 'white',
                '--toastProgressBackground': '#148a46'
            }
        })
    }
    
    export function notifyError (message) {
        
    }
</script>

<script>
    import { SvelteToast } from '@zerodevx/svelte-toast'
    
    import wait from '../../libs/wait'
    import {
        background as backgroundStore, 
        confirm as confirmStore 
    } from '../../stores/app'
    
    const toastOptions = { }

    const background = (bool) => {
        backgroundStore.set (bool)
    }

    const confirm = () => {
        confirmStore.set (true);
        wait (800).then (() => {
            confirmStore.set (false);
        })
    }

    API.background = background
    API.confirm = confirm
</script>

<style>
    /* .Toast {
        font-weight: bold;
    } */
</style>

<div class="Toast">
    <SvelteToast options={toastOptions} />
</div>